module.exports = __webpack_public_path__ + "img/kebijakan-undang-undang.d9be1b14.svg";